import React, { useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button } from "../ui/button";
import { Eraser } from "lucide-react";

// react-signature-canvas wipes on resize (tablet rotation) — restore from the last capture.
export const SignaturePad = ({ value, onChange }) => {
  const ref = useRef(null);

  useEffect(() => {
    const restore = () => setTimeout(() => {
      if (value && ref.current?.isEmpty()) ref.current.fromDataURL(value);
    }, 150);
    window.addEventListener("resize", restore);
    window.addEventListener("orientationchange", restore);
    return () => {
      window.removeEventListener("resize", restore);
      window.removeEventListener("orientationchange", restore);
    };
  }, [value]);

  const clear = () => { ref.current?.clear(); onChange(""); };

  return (
    <div className="space-y-2">
      <div className="rounded-lg border-2 border-dashed border-amber-300 bg-white" data-testid="signature-pad">
        <SignatureCanvas
          ref={ref}
          penColor="#0f172a"
          canvasProps={{ className: "w-full h-44 rounded-lg touch-none" }}
          onEnd={() => onChange(ref.current.isEmpty() ? "" : ref.current.toDataURL("image/png"))}
        />
      </div>
      <div className="flex items-center justify-between text-xs text-slate-500">
        <span>Client signs above with a finger or stylus</span>
        <Button type="button" size="sm" variant="ghost" onClick={clear} data-testid="signature-clear-button">
          <Eraser className="w-3.5 h-3.5 mr-1" />Clear
        </Button>
      </div>
    </div>
  );
};
